import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IPageMeta } from '@ztarmobile/zwp-service';
import { CHECKOUT_ROUTE_URLS, PLANS_SHOP_ROUTE_URLS, SHOP_ROUTE_URLS } from '../app.routes.names';
import { CheckCompatibilityComponent } from './check-compatibility/check-compatibility.component';
import { CheckoutResultComponent } from './checkout-result/checkout-result.component';
import { QuickMdnComponent } from './quick-top-up/quick-mdn/quick-mdn.component';
import { QuickSuccessComponent } from './quick-top-up/quick-success/quick-success.component';
import { QuickVoucherComponent } from './quick-top-up/quick-voucher/quick-voucher.component';
import { ShopMainComponent } from './shop.component';
import { CartComponent } from './cart/cart.component';
import { AuthEmailGuardService } from 'src/providers/user-auth-service/auth-email-guard.service';

const routes: Routes = [
  {
    path: '', component: ShopMainComponent, children: [
      {
        path: SHOP_ROUTE_URLS.CHECK_PHONE, component: CheckCompatibilityComponent,
        data: {
          title: `Check Your Phone's Compatibility With FreeUp Wireless Service | FreeUp Mobile`, description:
            'Does your phone work with FreeUp Mobile wireless service? Check your phone for compatibility or purchase a compatible phone from FreeUp Mobile.'
        } as IPageMeta
      },
      { path: SHOP_ROUTE_URLS.PLANS_AND_FEATURES, loadChildren: () => import('./plans-and-features/plans-and-features.module').then(m => m.PlansAndFeaturesModule) },
      { path: SHOP_ROUTE_URLS.PHONES.MAIN, loadChildren: () => import('./phones/phones.module').then(m => m.PhonesModule) },
      {
        path: SHOP_ROUTE_URLS.PLANS_AND_FEATURES_SHOP, redirectTo: `${SHOP_ROUTE_URLS.BASE}${PLANS_SHOP_ROUTE_URLS.BASE}/${PLANS_SHOP_ROUTE_URLS.NEW_PLAN}`, pathMatch: 'full', data: {
          title: 'Plans shop | FreeUp Mobile',
          description: `Your purchase with FreeUp Mobile is successful`
        } as IPageMeta
      },
      { path: CHECKOUT_ROUTE_URLS.NAME, loadChildren: () => import('./checkout/checkout.module').then(m => m.CheckoutModule), canActivate: [AuthEmailGuardService] },
      {
        path: SHOP_ROUTE_URLS.CHECKOUT_RESULTS, component: CheckoutResultComponent, data: {
          title: 'Purchase Successful | FreeUp Mobile',
          description: `Your purchase with FreeUp Mobile is successful`
        } as IPageMeta
      },
      {
        path: SHOP_ROUTE_URLS.MDN_QUICK_TOP_UP, component: QuickMdnComponent, data: {
          title: 'Quick Top-Up MDN | FreeUp Mobile',
          description: `It’s quick, easy and all you need is your FreeUp mobile and Voucher/PIN number`
        } as IPageMeta
      },
      {
        path: SHOP_ROUTE_URLS.VOUCHER_QUICK_TOP_UP, component: QuickVoucherComponent, data: {
          title: 'Quick Top-Up Voucher | FreeUp Mobile', description:
            `It’s quick, easy and all you need is your FreeUp mobile and Voucher/PIN number`
        } as IPageMeta
      },
      {
        path: SHOP_ROUTE_URLS.SUCCESS_QUICK_TOP_UP, component: QuickSuccessComponent, data: {
          title: 'Successful Quick Top-Up  | FreeUp Mobile', description:
            `It’s quick, easy and all you need is your FreeUp mobile and Voucher/PIN number`
        } as IPageMeta
      },
      { path: SHOP_ROUTE_URLS.CART, component: CartComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ShopRoutingModule { }
